import type { ColumnsType } from "antd/es/table/interface";
import { Link } from "react-router";
import { buildColumns } from "@/views/Data/TrialIssues/utils";
import {
  COLUMN_WIDTHS,
  FIXED_COLUMNS,
  HIDDEN_COLUMNS,
  SEARCHABLE_COLUMNS,
  TASK_COLUMN_ORDER,
  TITLE_MAPPING,
  type TaskTableRow,
} from "./utils";

/**
 * Headers come from the keys of the first row, so an empty list would render a
 * table with no columns at all. The Actions screen starts empty, so it builds
 * its columns from this template instead and shows the usual "No data" body.
 */
const EMPTY_ROW_TEMPLATE: TaskTableRow = {
  task_id: null,
  task_title: null,
  issue_id: null,
  signal: null,
  risk: null,
  description: null,
  assigned_role: null,
  priority: null,
  due_date: null,
  status: null,
  comments: null,
};

export const createTaskColumns = (
  rows: TaskTableRow[],
): ColumnsType<TaskTableRow> => {
  const columns = buildColumns({
    rows: rows.length ? rows : [EMPTY_ROW_TEMPLATE],
    columnOrder: TASK_COLUMN_ORDER,
    titleMapping: TITLE_MAPPING,
    columnWidths: COLUMN_WIDTHS,
    searchableColumns: SEARCHABLE_COLUMNS,
    fixedColumns: FIXED_COLUMNS,
    hiddenColumns: HIDDEN_COLUMNS,
    customRender: (header, text) => {
      if (header === "issue_id" && typeof text === "string" && text) {
        return (
          <Link
            className="text-[#06709B]"
            to={`../issues?openIssue=${text}`}
            relative="path"
            onClick={(e) => e.stopPropagation()}
          >
            {text}
          </Link>
        );
      }
      if (header === "risk" && typeof text === "string" && text) {
        return (
          <Link
            className="text-[#06709B]"
            to={`../risks?openRisk=${text}`}
            relative="path"
            onClick={(e) => e.stopPropagation()}
          >
            {text}
          </Link>
        );
      }
      return undefined;
    },
  }) as ColumnsType<TaskTableRow>;

  if (rows.length) return columns;
  // Filters built from the placeholder row would offer a single "-" option.
  return columns.map((column) => ({
    ...column,
    filters: undefined,
    onFilter: undefined,
  }));
};
